import $ from "jquery";
import Vue from "vue";
import Comments from "VueApps/comments/Comments.vue";
import {commentAxios} from "./commentAxios";
import store from "VueApps/comments/store";
import vueCustomElement from "vue-custom-element";
import vClickOutside from 'v-click-outside';
import VueMobileDetection from "vue-mobile-detection";
import {CHANGE_MATERIAL_URL_EVENT_NAME, GET_NEXT_MATERIAL_EVENT_NAME} from '../../common/events';
import {checkInView} from '../../common/materialContentWraperHelper';

const commentVueComponentMap = {};

commentAxios.defaults.headers.post['Content-Type'] = 'application/json';

commentAxios.interceptors.request.use(config => {
    config.validateStatus = (status) => {
        return status < 500;
    };
    return config;
});

commentAxios.interceptors.response.use(response => {
    if (response.status === 401) {
        $('#signin-button').click();

        return Promise.reject(response.data.message);
    }

    return {...response.data, httpCode: response.status}
});

if (isMocksEnabled) {
    require('./mocks');
}

Vue.use(vueCustomElement);
Vue.use(vClickOutside);
Vue.use(VueMobileDetection);

document.addEventListener(GET_NEXT_MATERIAL_EVENT_NAME, function (data) {
    if (data.detail.materialId === undefined) {
        return;
    }

    const commentElement = $(`#comments-component-${data.detail.materialId}`);

    if (commentElement.length > 0) {
        renderVue(commentElement);
    }
});

document.addEventListener(CHANGE_MATERIAL_URL_EVENT_NAME, function (event) {
    // const countHeaderWrapper = document.getElementById('comments-count-header');
    const countWrapper = document.getElementById('comments-count');

    if (countWrapper.length === 0 || commentVueComponentMap[event.detail.entityId] === undefined) {
        return false;
    }

    if (!checkInView(event.detail.entityId)) {
        return false;
    }

    countWrapper.innerHTML = commentVueComponentMap[event.detail.entityId].$store.state.componentState.totalCount;
    // countHeaderWrapper.innerHTML = commentVueComponentMap[event.detail.entityId].$store.state.componentState.totalCount;
});

$(() => {
    const commentsWrapper = $('.comment-replies');

    if (commentsWrapper.length > 0) {
        renderVue(commentsWrapper);
    }
});

const renderVue = (commentsWrapper) => {
    commentVueComponentMap[commentsWrapper.data('commentEntityId')] = new Vue({
        el: `#${commentsWrapper.prop('id')}`,
        store,
        render: h => h(Comments, {
            props: {
                type: commentsWrapper.data('commentType'),
                entityId: commentsWrapper.data('commentEntityId'),
                order: commentsWrapper.data('commentOrder'),
                scrollCommentId: commentsWrapper.data('scrollCommentId')
            }
        }),
    });
};
